var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResolvedCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z",
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7273 17C10.6582 17 10.5934 16.9888 10.533 16.9664C10.4725 16.9441 10.4164 16.906 10.3646 16.8523L8.13631 14.5436C8.04131 14.4452 7.99596 14.3177 8.00028 14.1611C8.0046 14.0045 8.05426 13.877 8.14926 13.7785C8.24427 13.6801 8.36518 13.6309 8.512 13.6309C8.65883 13.6309 8.77974 13.6801 8.87474 13.7785L10.7273 15.698L15.1191 11.1477C15.2141 11.0492 15.3371 11 15.4883 11C15.6394 11 15.7625 11.0492 15.8575 11.1477C15.9525 11.2461 16 11.3736 16 11.5302C16 11.6868 15.9525 11.8143 15.8575 11.9128L11.0901 16.8523C11.0382 16.906 10.9821 16.9441 10.9216 16.9664C10.8612 16.9888 10.7964 17 10.7273 17Z",
    fill: "#8A92A6",
    stroke: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0842 2.56737C15.7852 2.25637 15.2632 2.47037 15.2632 2.90137V5.53837C15.2632 6.64437 16.1742 7.55437 17.2802 7.55437C17.9772 7.56237 18.9452 7.56437 19.7672 7.56237C20.1882 7.56137 20.4022 7.05837 20.1102 6.75437C19.0552 5.65737 17.1662 3.69137 16.0842 2.56737Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResolvedCases);
export default __webpack_public_path__ + "static/media/Icon.ResolvedCases.f0a45b1b5e201a7894fa2c8b293c69ce.svg";
export { ForwardRef as ReactComponent };